/** Public, non-secret build identity used to compare a deployed UI with source. */
export const BUILD_COMMIT = process.env.REACT_APP_GIT_SHA?.trim() || 'unknown';

export function exposeBuildMetadata(documentRef: Document = document): void {
  let meta = documentRef.head.querySelector<HTMLMetaElement>('meta[name="luma-build-commit"]');
  if (!meta) {
    meta = documentRef.createElement('meta');
    meta.name = 'luma-build-commit';
    documentRef.head.appendChild(meta);
  }
  meta.content = BUILD_COMMIT;
}
